import React from 'react';
import SEO from '../../components/SEO/SEO';
import style from './NanoTestPage.module.css';

const NanoTestPage = () => {
	const bgImage = `${process.env.PUBLIC_URL || ''}/red-apple-white-bg.png`;

	return (
		<div
			className={style.NanoTestPage}
			style={{ backgroundImage: `url(${bgImage})` }}
			role="img"
			aria-label="Red apple on white background"
		>
			<SEO
				title="Nano test"
				description="Nano Banana image test page."
				path="/nanotest"
			/>
		</div>
	);
};

export default NanoTestPage;
